module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/lion-pic.f3294309.png";